import { getAjax, postAjax } from './index.js';

/**
 * 获取仓库列表
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const getWarehouseList = (data = {}, params = {}) => {
  return getAjax('trade/warehouse/list', data, params);
};

// 获取商品列表
export const getCommodityData = (data = {}, params = {}) => {
  return postAjax('stock/queryExtList', data, params);
};
/**
 * 获取快递模板列表
 * @param {*} data
 * @returns
 */
export const getWarehouseTemplateList = (data = {}) => {
  return getAjax('trade/warehouse/template/simple/list', data);
};

/**
 * 获取订单所有的数据
 * @param {*} data
 * @returns
 */
export const getTradeSearchData = data => {
  return postAjax('trade/search', data);
};

export const getTradeBySids = data => {
  return postAjax('trade/search/sids', data);
}

// 获取快递公司
export const getExpressTemplateList = async (params = {}) => {
  const { data = {} } = await postAjax('pt/expresstemplate/groupbyexpresssid/get', params, { submitType: 'json' });
  return data;
};

// 获取分销商
export const queryDmsDistributorInfoList = async (params = {}) => {
  const { data = {} } = await postAjax('trade/dms/queryDmsDistributorInfoList', params);
  return data;
};

/**
 * 根据昵称获取收件人信息
 * @param {*} data
 * @returns
 */
export const getReceiversByCmNick = (data = {}) => {
  return postAjax('cm/receiver/getReceiversByCmNick', data);
};

/**
 * 地址自动匹配
 * @param {*} data
 * @returns
 */
export const getAiParseAddress = (data = {}) => {
  return getAjax('trade/aiParseAddress', data);
};

/**
 * 新建订单
 * @param {*} data
 * @returns
 */
export const createOrderSave = (data = {}) => {
  return postAjax(
    'trade/save?ifChangeTradeDmsAttr=1',
    { ...data, ifChangeTradeDmsAttr: 1, force: true, },
    { submitType: 'json', isNeedFailNotice: true }
  );
};

/**
 * 订单审核
 * @param {*} sids
 * @returns
 */
export const auditTrade = (data = {}) => {
  return postAjax('trade/audit', 
    { ...data, ifChangeTradeDmsAttr: 1 },
    { isNeedFailNotice: true }
  );
};

/**
 * 处理三方仓异常
 * @param {*} data
 * @returns
 */
export const handleParty3Except = (data = {}) => {
  return postAjax('trade/dms/party3ExceptHandle', data, { isNeedFailNotice: true });
};



/**
 * 获取订单合并的收货地址信息
 * @param {*} sids
 * @returns
 */
export const tradeMergeCheckNick = (data = {}) => {
  return postAjax('trade/merge/checkNick', data);
};

/**
 * 获取解密的收货信息
 * @param {*} sid
 * @returns
 */
export const decryptReceiverInfo = (data = {}) => {
  return getAjax('trade/decrypt/receiver/info', data);
};

/**
 * 订单合单
 * @param {*} sids
 * @param {*} force 默认是0
 * @param {*} masterSid
 * @returns
 */
export const mergeTrade = (data = {}) => {
  return postAjax('trade/merge', data);
};

/**
 * 订单跨店合单
 * @param {*} sids
 * @param {*} force 默认是0
 * @param {*} masterSid
 * @returns
 */
export const mergeTradeMulti = (data = {}) => {
  return postAjax('trade/merge/multi', data);
};

/**
 * 取消合单
 * @param {*} params 
 */
export const mergeTradeCancel = (params = {}) => {
  return postAjax('trade/batch/merge/undo', params);
};

/**
 * 取消合单
 * @param {*} params 
 */
export const splitTradeCancel = (params = {}) => {
  return postAjax('trade/split/undo/batch', params);
};



/**
 * 作废订单
 * @param {*} sids
 * @param {*} force 默认是0
 * @returns
 */
export const cancelTrade = (data = {}) => {
  return postAjax('trade/cancel', data, { isNeedFailNotice: true });
};

/**
 * 取消作废订单
 * @param {*} sids
 * @returns
 */
export const unCancelTrade = (data = {}) => {
  return postAjax('trade/uncancel', data);
};

/**
 * 转异常
 * @param {*} data
 * @returns
 */
export const tradeExceptUpdate = (data = {}) => {
  return postAjax('trade/except/update', data);
};

/**
 * 取消异常
 * @param {*} sids
 * @returns
 */
export const cancelTradeException = (data = {}) => {
  return postAjax('trade/exception/cancel', data);
};

/**
 * 查询进度
 * @param {*} progressType
 * 其中不同的操作progressType值如下：
 * 审核：91
 * 转异常：51
 * 取消异常：52
 * 新增分销属性/自发转代发: 55
 * 取消分销属性/代发转自发：905
 * 平台上传发货：23
 * 修改平台备注：9
 * 换商品： 90
 * 反审核/撤回：53
 * 缺货审核：24
 * 取消作废： 290
 * 供销拆分：26
 * @returns
 */
export const queryTradeProgress = (data = {}) => {
  let url = data.url || 'trade/progress/query';
  delete data.url;
  return postAjax(url, data, { isNeedLoading: false });
};

/**
 * 新增分销属性/自发转代发
 * @param {*} sids
 * @returns
 */
export const addDistributorAttribute = (data = {}, params = {}) => {
  return postAjax('trade/dms/addDistributorAttribute', { ...data, addDistributorAttributeType: 1 }, params);
};

/**
 * 取消分销属性/代发转自发
 * @param {*} sids
 * @returns
 */
export const cancelDistributorAttribute = (data = {}) => {
  return postAjax('trade/dms/cancelDistributorAttribute?ifKmtCancelDistributor=1', data);
};

/**
 * 平台上传发货
 * @param {*} data
 * @returns
 */
export const batchPlatformUploadDelivery = (data = {}) => {
  return postAjax('trade/consign/upload/batch', data);
};

/**
 * 批量修改备注
 * @param {*} data
 * @returns
 */
export const batchUpdateSellerMemo = (data = {}) => {
  return postAjax('trade/sellerMemo/batchUpdate', data);
};

/**
 * 单个修改备注
 * @param {*} data
 * @returns
 */
export const singleUpdateSellerMemo = (data = {}) => {
  return postAjax('trade/sellermemoflag/update', data);
};
/**
 * 批量换商品
 * @param {*} sids
 * @param {*} num
 * @param {*} itemSysId
 * @param {*} skuSysId
 * @param {*} isVirtual
 * @param {*} outerId
 * @param {*} outerSkuId
 * @param {*} title
 * @returns
 */
export const exchangeProdItem = (data = {}) => {
  return postAjax('trade/change/replaceRemoveItem', { ...data, ifChangeTradeDmsAttr: '1' });
};

/**
 * 单店铺/多店铺导入
 * @param {*} data
 * @returns
 */
export const uploadFileRequest = (data = {}) => {
  return postAjax('trade/import', data, { submitType: 'form-data', headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 店铺导入进度查询
 * @param {*} data
 * @returns
 */
export const tradeImportProgress = (data = {}) => {
  return postAjax('trade/import/progress', data, { isNeedLoading: false });
};

/**
 * 反审核/撤回 - erp中的取消审核
 * @param {*} data
 * @returns
 */
export const unauditTrade = (data = {}) => {
  return postAjax('trade/unaudit', data);
};

/**
 * 获取tab的数据
 * @param {*} data
 * @returns
 */
export const getTradeCount = (data = {}) => {
  return postAjax('trade/count', data, { isNeedLoading: false });
};

/**
 * 获取全部异常和标签列表
 * @param {*} kind 异常标签为 1,  系统标签 0
 * @param {*} ignoreUnattainable 默认为1
 * @returns
 */
export const getTradeTagList = (data = {}) => {
  return postAjax('trade/tag/list', data);
};
/**
 * 删除
 * @returns
 */
export const deleteTradeTag = (data = {}) => {
  return postAjax('trade/tag/delete', data);
};

/**
 * 新增标签和异常   kind:0标签  1异常
 * @returns
 */
export const insertTradeTag = (data = {}) => {
  return postAjax('trade/tag/insert', data);
};

/**
 * 批量修改标签
 * @param {*} sids
 * @param {*} flag
 * @param {*} tagIds
 * @returns
 */
export const addOrCoverTradeTag = (data = {}) => {
  return postAjax('trade/tag/addOrCover', data);
};

/**
 * 混合拆分
 * @param {*} sid
 * @param {*} orders [{id, num, splitNum }]
 * @returns
 */
export const mixSplitTrade = (data = {}, groupCount) => {
  return postAjax(`trade/split/mix?groupCount=${groupCount}`, data, { submitType: 'json' });
};

/**
 * 查询输入的商家编码的商品信息
 * @param {*} outerId
 * @returns
 */
export const queryItemOuter = (data = {}) => {
  return postAjax('item/query/outer', data);
};

/**
 * 获取快捷查询列表
 * @returns
 */
export const getTradeSearchCustomList = async params => {
  const res = getAjax('trade/search/custom/list', params);
  return res;
};
/**
 * 删除快捷查询项
 * @returns
 */
export const deleteTradeSearchCustom = async params => {
  const res = postAjax('trade/search/custom/delete', params);
  return res;
};
/**
 * 修改快捷查询分组
 * @returns
 */
export const exchangeTradeSearchCustomGroup = async params => {
  const res = postAjax('trade/search/custom/exchange/group', params);
  return res;
};
/**
 * 新增分组
 * @returns
 */
export const saveTradeSearchCustomGroup = async params => {
  const res = postAjax('trade/search/custom/save', params);
  return res;
};

/**
 * 获取运单号
 * @param {*} sids
 * @returns
 */
export const getPtWayBillCode = (data = {}) => {
  return postAjax('pt/waybill/code/get', data);
};

/**
 * 供销拆分 - 勾选订单拆分
 * @param {*} data
 */
export const supplySplitTrade = (data = {}) => {
  return postAjax('trade/split/supply', data);
};

/**
 * 修改商品保存
 */
export const updateTradeSave = (data = {}) => {
  let params = { trade: { ...data, ifChangeTradeDmsAttr: '1' } }
  return postAjax(`trade/platform/save?ifChangeTradeDmsAttr=1`, params, { submitType: 'json' });
};

/**
 * 删除标签
 */
export const delTradeTag = (data = {}) => {
  return postAjax(`trade/tag/delTradeTag`, data);
};
/**
 * 获取详细信息
 */
export const getReceiversInfo = (data = {}) => {
  return getAjax(`trade/decrypt/receiver/info`, data);
};
/**
 * 更改订单地址
 */
export const updateTradeAddress = (data = {}) => {
  return postAjax(`trade/shippingaddress/update`, data);
};
/**
 * 获取供销商
 */
export const kmtSupplier = (data = {}) => {
  return postAjax(`item/kmt/supplier/allSupplier`, data);
};

/**
 * 获取订单详情
 * @param {*} data
 * @returns
 */
export const getTradeDetail = (data = {}) => {
  return getAjax('trade/detail', data);
};

/**
 * 系统发货 -> 打印发货
 * @param {*} sids
 * @param {*} templateId
 * @param {*} printBatchId
 * @param {*} printCountNum
 * @param {*} tradeCountNums
 * @param {*} exceptionPrint
 * @param {*} printer
 * @returns
 */
export const tradeSysPrintDelivery = (data = {}) => {
  return postAjax('trade/print/cloud/data/printer', data);
};

/**
 * 系统发货 -> 直接发货
 * @param {*} sids 订单号 多个,拼接
 */
export const tradeSendDirect = (data = {}) => {
  return postAjax('trade/consign/audited', data);
};

/**
 * 缺货审核
 * @param {*} data
 * @returns
 */
export const insufficientAudit = (data = {}) => {
  return postAjax('trade/audit/insufficient', data);
};

/**
 * 修改运费
 * @param {*} sid
 * @param {*} postfee
 * @returns
 * /**
 * 修改实际运费
 * @param {*} sids
 * @param {*} actualPostFee
 * @returns
 */
export const updateTradePostFee = (data = {}, type) => {
  let url = type == 'postFee' ? 'trade/postfee/update' : 'trade/actualPostFee/update';
  return postAjax(url, data);
};

/**
 * 获取物流信息
 * @param {*} sid
 * @param {*} taobaoId
 * @param {*} tid
 * @returns
 */
export const getTradeLogisticsInfo = (data = {}, options = {}) => {
  return getAjax('trade/logistics/trace/search', data, { submitType: 'json', isNeedFailNotice: true, ...options });
};

/**
 * 获取操作日志
 * @param {*} sid
 * @param {*} isLog
 * @returns
 */
export const getTradeTraceDetail = (data = {}, {isNeedLoading = true} = {}) => {
  return getAjax('trade/trace/detail', data, { submitType: 'json', isNeedLoading });
};

/**
 * 获取多快递信息
 * @param {*} data
 * @returns
 */
export const getMultiPacketData = (data = {}) => {
  return postAjax('trade/multipacks/outSid/query', data);
};

/* 快速换商品
 * @param {*} sid
 * @param {*} id
 * @param {*} itemSysId 取的sysItemId
 * @param {*} skuSysId 取sysSkuId字段或为-1
 * @returns
 */
export const changeTradeItem = (data = {}) => {
  return postAjax('trade/change/item', data, { isNeedFailNotice: true });
};

/**
 * 获取异常数量等信息
 * @returns 
 */
export const getTradeStat = (params = {}) => {
  return postAjax('trade/stat', params, { isNeedLoading: false })
}

/**
 * 处理商品未匹配
 * @returns
 */
export const matchOuterId = ((data = {}) => {
  return postAjax('trade/item/match/outerId', data);
});

/**
 * 处理对应关系改动
 * @returns
 */
export const matchRelation = ((data = {}) => {
  return postAjax('trade/item/match/relation', data);
});

/**
 * 强制推单至供销商
 */
export const forcePushTradeToGx = (data = {}) => {
  return postAjax('trade/dms/forcePushTradeToGx', data);
}

/**
 * 获取分销付款数据
 */
export const getFxPayInfo = (data = {}, opt = {}) => {
  return postAjax('trade/dms/getPaymentInfo', data, opt).then(res => res.data);
}

/**
 * 待付款订单付款成功后调用转为后续系统状态订单
 * @param {*} params 
 * @returns 
 */
export const paySuccess = (params) => {
  return postAjax('trade/dms/paySuccess', params);
}

/**
 * 催供销商发货接口
 */
export const urgingSupplierShip = (data = {}) => {
  return postAjax('trade/dms/urging/supplier/ship', data);
}

/**
 * 获取物流预警单据数量
 */
export const getLogisticsStatistics = (data = {}) => {
  return postAjax('trade/dms/logistics/statistics', data, {isNeedLoading: false});
}

/**
 * 获取物流预警单据的sid
 */
export const getLogisticsStatisticsSids = (data = {}) => {
  return postAjax('trade/dms/logistics/sids', data);
}

/**
 * 获取修改商品的日志
 */
export const getItemModifyLogs = (sid) => {
  return getAjax('trade/trace/itemModify/detail', {sid, isLog: true}, { isNeedLoading: false }).then(res => {
    return res.data?.traces || [];
  })
}

/**
 * 线下发货
 */
export const fxHandleGxConsign = (data = {}) => {
  return postAjax(`trade/dms/fxHandleGxConsign`, data, { submitType: 'json', isNeedFailNotice: true });
};

/**
 * 获取供销商公司信息
 * @param {Object} data - 参数对象
 * @param {string} data.sid - 订单sid
 * @returns {Promise} 返回供销商信息对象 { companyId, companyName, ... }
 */
export const getFinalCompanyInfo = (data = {}) => {
  return postAjax('trade/dms/getFinalCompanyInfo', data);
};
